import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xpgzk3jdj5: FaireBrandEntity = {
  token: "b_xpgzk3jdj5",
  type: "brand",
  name: "Chippys",
  avatarUrl:
    "https://cdn.faire.com/fastly/49f7d470b25e5f47ac61cb172003dbd31452be3fd6eae9684a16aaf7aad0e2a1.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/28283dafaad45e6111437ea7c54781b99b56cc1dc245eee3ff0bf98a6b631bea.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/49f7d470b25e5f47ac61cb172003dbd31452be3fd6eae9684a16aaf7aad0e2a1.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/28283dafaad45e6111437ea7c54781b99b56cc1dc245eee3ff0bf98a6b631bea.jpeg",
  location: "Irvine, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "CHIPPYS was born from a simple idea that snacks should be both joyful and better for you. We handcraft our potato chips in small batches using 100% grass-fed beef tallow, giving them a rich crunch and flavor you just can’t find in seed oil chips. As a woman and veteran-owned brand, we are proud to stand for Non-GMO, gluten free, and seed oil free snacking. Every bag of CHIPPYS is made with care to bring a little more happiness, honesty, and heart to your snack aisle.",
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:47.549Z",
    importedBy: "entity-db-cli",
  },
};
